const mapConfig = {
  defaultLat: 40,
  defaultLng: -110,
  defaultZoom: 5,
  tileUrl: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  tileAttrib: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
};
Object.assign(mapConfig, {
  pointZoom: mapConfig.defaultZoom + 6,
});

export default mapConfig;
